import PhotoThumbnail from './PhotoThumbnail';

export default function PhotoGrid({ photos, onSelect, selectedIds = new Set(), creditMap = new Map(), renderOverlay, columns }) {
  const gridClass = columns
    ? `photo-grid-container cols-${columns}`
    : 'photo-grid-container cols-auto';

  return (
    <div className={gridClass} style={{ display: 'grid', gap: '8px' }}>
      {photos.map((photo, index) => (
        <PhotoThumbnail
          key={photo.id}
          photo={photo}
          isSelected={selectedIds.has(photo.id)}
          status={creditMap.get(photo.id)}
          onClick={() => onSelect(index)}
          overlayAction={renderOverlay ? renderOverlay(photo) : null}
        />
      ))}
    </div>
  );
}